import React, { useEffect, useState } from "react";

import { Row, Col, Card, Table, Button, Typography, Pagination, Input, Tag } from "antd";

import { ClearOutlined, SearchOutlined } from "@ant-design/icons";

import { columnsExpedienteVirtualUsuario } from "../helpers/columnsExpedienteVirtual";

import { ObtenerExpedienteVirtualUsuario } from "../actions/expedienteActions";
import { FormatPhoneNumber } from "../helpers/FormatPhoneNumber";

const { Title, Text } = Typography;

export const ConsultarUsuario = () => {

    const [page, setPage] = useState( 1 );
    const [rowsPerPage, setRowsPerPage] = useState( 10 );
    const [recordsCount, setRecordsCount] = useState( 0 );
  
    const [data, setData] = useState( [] );

    const [loading, setLoading] = useState( false );    
    
    const [correoElectronico, setCorreoElectronico] = useState( '' );
    const [telefonoCelular, setTelefonoCelular] = useState( '' );
    const [numeroExpediente, setNumeroExpediente] = useState( '' );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const handleLimpiarFiltro = () => {

        setFiltroAplicado( false );
        
        setCorreoElectronico( '' );     
        setTelefonoCelular( '' );     
        setNumeroExpediente( '' );

        setPage( 1 );
        setRecordsCount( 0 );
        setData( [] );
    }

    const handleBuscar = async () => {

        setFiltroAplicado( true )
        setPage( 1 );

        setLoading(true);
        setData( [] );

        await ObtenerExpedienteVirtualUsuario({ page: page - 1, rowsPerPage, correoElectronico, telefonoCelular: FormatPhoneNumber( telefonoCelular ), numeroExpediente }).then(response => {

            if ( response ) {

                if ( response.status === 200 ) {

                    if ( response.data ) {

                        setTimeout(() => {

                            setRecordsCount(response.data.recordsCount ?? 0);

                            var data = response?.data?.records.map( ( elem ) => {

                                    let estatus = <Text></Text>

                                    if( elem.estatus === 'Activo' ){
                                        estatus = <Tag color={"green"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                                    }
                                    else if( elem.estatus === 'Inactivo' ){
                                        estatus = <Tag color={"volcano"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                                    }
                                    else if( elem.estatus === 'Archivado' ){
                                        estatus = <Tag color={"gold"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                                    }
                                    
                                    return {
                                        key: elem.idExpediente,
                                        folio: <Title level={5}>{elem.folio !== '0' ? elem.folio : '' }</Title>,
                                        expediente: <Title level={5}>{elem.numeroExpediente}</Title>,
                                        juzgado: <Title level={5}>Juzgado {elem.tipoJuzgado} Primera Instancia en Materia {elem.materia} del distrito Judicial de {elem.distritoJudicial}</Title>,
                                        actor: <Title level={5}>{elem.actor}</Title>,
                                        demandado: <Title level={5}>{elem.demandado}</Title>,
                                        estatus: estatus,    
                                    }
                            })
                                
                            setLoading( false );
                            setData( data );

                        }, 700);

                    }

                }

            }

        });
    }

    useEffect(() => {

        async function Obtener() {

            setLoading(true);
            setData([]);

            await ObtenerExpedienteVirtualUsuario({ page: page - 1, rowsPerPage, correoElectronico, telefonoCelular: FormatPhoneNumber( telefonoCelular ), numeroExpediente }).then(response => {

                if ( response ) {
    
                    if ( response.status === 200 ) {
    
                        if ( response.data ) {
    
                            setTimeout(() => {
    
                                setRecordsCount(response.data.recordsCount ?? 0);

                                var data = response?.data?.records.map( ( elem ) => {

                                    let estatus = <Text></Text>

                                    if( elem.estatus === 'Activo' ){
                                        estatus = <Tag color={"green"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                                    }
                                    else if( elem.estatus === 'Inactivo' ){
                                        estatus = <Tag color={"volcano"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                                    }
                                    else if( elem.estatus === 'Archivado' ){
                                        estatus = <Tag color={"gold"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                                    }
                                    
                                    return {
                                        key: elem.idExpediente,
                                        folio: <Title level={5}>{elem.folio !== '0' ? elem.folio : '' }</Title>,
                                        expediente: <Title level={5}>{elem.numeroExpediente}</Title>,
                                        juzgado: <Title level={5}>Juzgado {elem.tipoJuzgado} Primera Instancia en Materia {elem.materia} del distrito Judicial de {elem.distritoJudicial}</Title>,
                                        actor: <Title level={5}>{elem.actor}</Title>,
                                        demandado: <Title level={5}>{elem.demandado}</Title>,
                                        estatus: estatus,    
                                    }
                                });
                                    
                                setLoading( false );
                                setData( data );
    
                            }, 700);
    

                        }

                    }

                }

            });
        }
        
        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, correoElectronico, telefonoCelular, numeroExpediente ])

    return (
        <>

            <div className="tabled">

                <Row gutter={[24, 0]}>

                    <Col xs="24" xl={24} >

                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            style={{ width: '100%', padding: '1em' }}
                        >

                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ marginBottom: 20 }} justify='end'>

                                <Col className="gutter-row" span={6}>
                                    <Input placeholder="Buscar usuario por correo electronico" value={ correoElectronico } onChange={(e) => { setCorreoElectronico(e.target.value) }} disabled={ filtroAplicado }/>
                                </Col>

                                <Col className="gutter-row" span={6}>
                                    <Input placeholder="Buscar usuario por teléfono celular" value={ telefonoCelular } onChange={(e) => { setTelefonoCelular(e.target.value) }} disabled={ filtroAplicado }/>
                                </Col>

                                <Col className="gutter-row" span={6}>
                                    <Input placeholder="Buscar por número de expediente" value={ numeroExpediente } onChange={(e) => { setNumeroExpediente(e.target.value) }} disabled={ filtroAplicado }/>
                                </Col>

                                <Col className="gutter-row" span={6}  >
                                    <Button style={{ fontSize: '14px', width: '100%' }} icon={ filtroAplicado ? <ClearOutlined /> : <SearchOutlined /> } onClick={ () => filtroAplicado ? handleLimpiarFiltro() : handleBuscar() } disabled={ ( correoElectronico === '' && telefonoCelular === '' && numeroExpediente === '' ) } loading={ loading }>
                                        { filtroAplicado ? 'Limpiar' : 'Buscar' }
                                    </Button>
                                </Col>
                                
                            </Row>

                        </Card>
                                
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            style={{ width: '100%' }}
                        >
                            <div className="table-responsive" style={{ marginTop: '20px' }}>

                                <Table
                                    className="ant-border-space"
                                    dataSource={ data }
                                    pagination={ false }
                                    columns={ columnsExpedienteVirtualUsuario }
                                    loading={ loading }
                                />

                            </div>

                            <div style={{ float: 'left', padding: '15px' }} >
                                <Title level={5}>Total de expedientes: { recordsCount }</Title>
                            </div>

                            <div style={{ float: 'right', padding: '15px' }} >
                                <Pagination 
                                    current={ page }
                                    pageSize={ rowsPerPage }
                                    total={ recordsCount } 
                                    onChange={ ( page, pageSize ) => { setPage( page ); setRowsPerPage( pageSize ); } } 
                                />
                            </div>

                        </Card>

                    </Col>

                </Row>

            </div>
            
        </>
    );

}
